import { OrderCriteria } from '@nemuru-eng/js-api-client';

import { getIconByAssetOrArticleType } from '@/components/modules/LoanListByProduct/utils/getIconByAssetOrArticleType';
import { SizedIconWithCircle } from '@/components/shared/components/SizedIconWithCircle';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const articleTypeFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    field: 'article_type',
    sortable: false,
    headerName: <Text tId={'TYPE'} />,
    disableOnRowClick: true,
    renderCell: (rowData: { row: OrderCriteria }) => {
      return (
        <SizedIconWithCircle
          variant={'medium'}
          backgroundColor={palette.grey[50]}
          iconColor={palette.grey[500]}
          customBorderRadius={customBorderRadius.chip}
          iconName={rowData.row.articleType ? getIconByAssetOrArticleType(rowData.row.articleType) : ''}
          copyToClipboard={{ value: rowData.row.loanId ?? rowData.row.id, textId: 'COPY_ORDER_ID' }}
        />
      );
    },
  };
};
